import React, { ReactNode, useState } from 'react';

import { ClickAwayListener, Tooltip } from '@material-ui/core';

import { useScreenSize } from '../../hooks/use-screen-size';
import { CloseButton } from '../close-button';
import { ThemedButton } from '../themed-button';

import { useStyles } from './style';
import clsx from 'clsx';

interface Props {
  text: string | ReactNode;
  className?: string;
  showButton?: boolean;
  disabled?: boolean;
  isOpened?: boolean;
  onClose?: () => void;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

export const WarningTooltip: React.FC<Props> = ({ showButton = true, className, children, text, placement = 'top', disabled, isOpened, onClose }) => {
  const classes = useStyles();
  const { isDesktop } = useScreenSize();
  const [isOpen, setIsOpen] = useState(false);

  const closeTooltip = () => {
    onClose && onClose();
    setIsOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={isDesktop || onClose ? () => {} : closeTooltip}>
      <Tooltip
        disableTouchListener={true}
        disableFocusListener={true}
        disableHoverListener={!isDesktop || !!onClose}
        arrow={true}
        classes={{
          tooltip: clsx(classes.rootTooltip, className),
          arrow: classes.arrow,
        }}
        title={
          <div className={classes.tooltip}>
            <div className={classes.tooltipText}>{text}</div>
            {showButton && <ThemedButton onClick={closeTooltip} title='Ok' width={100} isSmall={true} />}
            <CloseButton customClass={classes.closeTooltip} onClick={closeTooltip} />
          </div>
        }
        interactive={true}
        open={isOpened ? !!isOpened : isOpen && !disabled}
        onOpen={setIsOpen.bind(null, true)}
        onClose={setIsOpen.bind(null, false)}
        placement={placement}
      >
        <div onClick={isDesktop ? undefined : setIsOpen.bind(null, true)}>{children}</div>
      </Tooltip>
    </ClickAwayListener>
  );
};
